@if (selectedOrderType && selectedShippingAddress && selectedShippingType && nativeDeliveryDate) {
  <span class="small d-none d-md-inline header-summary-text">(
    {{ selectedOrderType.name }}
    /
    {{ selectedShippingAddress.line1 }} {{ selectedShippingAddress.line2 }}, {{ selectedShippingAddress.postalCode }} {{ selectedShippingAddress.town }}
    /
    {{ selectedShippingType.name }}
    @if (displayRequestedDeliveryDate) {
      /
      {{ nativeDeliveryDate | cxDate: 'dd.MM.yyyy' }}
    }
  )</span>
}
